var map = {
	"./ActionLogging.svg": "3c21",
	"./Alert.svg": "080a",
	"./ArchiveManagerLocal.svg": "e363",
	"./ArchiveManagerNetwork.svg": "8944",
	"./AttachingFiles.svg": "1b15",
	"./AutoSendToApproval.svg": "893e",
	"./Branches.svg": "4a1d",
	"./Bulk.svg": "cf8e",
	"./BulkSigning.svg": "ec61",
	"./DocumentImport.svg": "a428",
	"./DocumentRouting.svg": "c00d",
	"./DocumentStorage.svg": "98eb",
	"./ETSPVia.svg": "7d69",
	"./ElectronicChecks.svg": "2b5a",
	"./Employees.svg": "65c8",
	"./Filter.svg": "3111",
	"./HelpInvoice.svg": "3e50",
	"./HybridMail.svg": "84d0",
	"./IndividualReports.svg": "29bd",
	"./Manual.svg": "7960",
	"./MapMonitoring.svg": "ba98",
	"./OperationsHistory.svg": "cfad",
	"./OrganizationManagement.svg": "5e6e",
	"./POSTerminal.svg": "c9e7",
	"./RegisterOfDocuments.svg": "6c52",
	"./RoamingDocuments.svg": "248d",
	"./StepByStepApproval.svg": "5d5c",
	"./Subdivisions.svg": "253b",
	"./Synchronization.svg": "77e3",
	"./Tags.svg": "f955",
	"./TypeReport.svg": "4b2e",
	"./VATReport.svg": "0528",
	"./tuzukai.jpg": "359d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f1b";